import { render, staticRenderFns } from "./OpenPage.vue?vue&type=template&id=1909c72a"
import script from "./OpenPage.vue?vue&type=script&lang=js"
export * from "./OpenPage.vue?vue&type=script&lang=js"
import style0 from "./OpenPage.vue?vue&type=style&index=0&id=1909c72a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports